import { V2CreationData } from '@/apis/aniftyBackend/creations/interface';

export type CreationStatus =
  | 'notListed'
  | 'marketplaceV1'
  | 'marketplaceV2'
  | 'auction'
  | 'marketplaceV2Ipfs'
  | 'auctionIpfs';

const getCreationStatus = (creationData: V2CreationData): CreationStatus => {
  if (!creationData) {
    throw new Error(`Creation data is not provided`);
  }

  // case 1: not listed
  // no mintAsk nor token ID
  if (!creationData.mintAsk && !creationData.aniftyTokenID) {
    return 'notListed';
  }

  // case 2: Marketplace V1
  // We may want to add check for creationID for if statement
  if (!creationData.mintAsk && creationData.aniftyTokenID) {
    return 'marketplaceV1';
  }

  // case 3: MarketplaceV2Ipfs
  if (creationData.mintAsk.tokenVersionID === 2) {
    if (creationData.mintAsk.askType === 0) {
      return 'marketplaceV2Ipfs';
    }

    if (creationData.mintAsk.askType === 1) {
      return 'auctionIpfs';
    }
  // case 4: MarketplaceV2
  } else {
    if (creationData.mintAsk.askType === 0) {
      return 'marketplaceV2';
    }

    if (creationData.mintAsk.askType === 1) {
      return 'auction';
    }
  }

  throw new Error(`Failed to determine creation status`);
};

export default getCreationStatus;
